import * as React from 'react';

interface I18nContextValue {
	ready: boolean;
}

const I18nContext = React.createContext<I18nContextValue | null>(null);

export { I18nContext };
